/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Drawer_Plans_CountInputs */

const en_drawer_plans_count = /** @type {(inputs: Drawer_Plans_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} plans`)
};

const id_drawer_plans_count = /** @type {(inputs: Drawer_Plans_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} rencana`)
};

/**
* | output |
* | --- |
* | "{n} plans" |
*
* @param {Drawer_Plans_CountInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_plans_count = /** @type {((inputs: Drawer_Plans_CountInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_Plans_CountInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_plans_count(inputs)
	return en_drawer_plans_count(inputs)
});